import React, { Fragment, useContext } from 'react'
import { Row } from 'reactstrap'
import { useLocation } from 'react-router-dom'
import CustomContext from '../../_helper/Customizer'
import MoonLight from './MoonLight'
import UserHeader from './UserHeader'
import InstructorHorizontalMenu from './InstructorHorizontalMenu'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import './InstructorHorizontalMenu.css'

import { UL } from '../../AbstractElements'
import { Col } from 'reactstrap'

const Header = () => {
	const { toggleIcon } = useContext(CustomContext)
	const location = useLocation()
	const { user } = useAuth()

	// Function to check if we're on a student task page
	const isStudentTaskPage = () => {
		const path = location.pathname
		return path.includes('/student-tasks/') || path.includes('/student-task-edit/') || path.includes('/checklist-edit/')
	}

	// Function to extract student ID from URL
	const getStudentIdFromPath = () => {
		const path = location.pathname
		const pathParts = path.split('/')

		// For student-tasks/:studentId/:layout
		if (path.includes('/student-tasks/')) {
			const studentIndex = pathParts.findIndex((part) => part === 'student-tasks')
			return studentIndex !== -1 ? pathParts[studentIndex + 1] : null
		}

		// For checklist-edit/:slug/:status/:id/:layout
		if (path.includes('/checklist-edit/')) {
			const slugIndex = pathParts.findIndex((part) => part === 'checklist-edit')
			return slugIndex !== -1 ? pathParts[slugIndex + 1] : null
		}

		return null
	}

	const studentId = getStudentIdFromPath()

	return (
		<Fragment>
			<div className={`page-header ${toggleIcon ? 'close_icon' : ''}`}>
				<Row className="header-wrapper m-0 align-items-center">
						{/* Instructor Menu Area (Spaced across the header) */}
						<Col className="p-0 d-flex align-items-center flex-grow-1 ms-3">
							{user?.role === 'Instructor' && (
								<InstructorHorizontalMenu isCompact={isStudentTaskPage() && studentId} />
							)}
						</Col>

						{/* System and Profile Icons Area (Original nav-right) */}
						<Col xs="auto" className="nav-right pull-right right-header p-0 ms-auto">
							<UL attrUL={{ className: 'simple-list nav-menus flex-row align-items-center justify-content-end' }}>
								<MoonLight />
								<UserHeader />
							</UL>
						</Col>
				</Row>
		</div>
	</Fragment>
	)
}

export default Header
